"use strict";

// if this is executing on client side
//if (process.env.NODE_ENV == null) {
//	// use env defined by grunt task
//	process.env = require("env");
//}
const env     = process.env.APP_ENV || process.env.NODE_ENV || "development";
const port    = process.env.NODE_WEBAPP_PORT || 9002;
const host    = process.env.NODE_HOST || "0.0.0.0";
const version = process.env.WEBAPP_VERSION ? "/" + process.env.WEBAPP_VERSION : "";
const _       = require("underscore");

const publicUrl = process.env.PUBLIC_DOMAIN;

const app = {
  production : {
    apiURL                  : "https://private.agendor.com.br/v1",
    apiRailsURL             : "https://private.agendor.com.br/v2",
    webURL                  : "https://web.agendor.com.br",
    webAppURL               : (publicUrl || "https://app.agendor.com.br") + version,
    integrationsURL         : "https://private.agendor.com.br/integrations/google-calendar",
    biURL                   : "https://private.agendor.com.br/bi",
    rdStationIntegrationURL : "https://in.agendor.com.br/rd",
    betaURL                 : "https://beta.agendor.com.br"
  },
  beta : {
    apiURL                  : "https://api.agendor.com.br/v1",
    apiRailsURL             : "https://api.agendor.com.br/v2",
    webURL                  : "https://beta.agendor.com.br",
    webAppURL               : (publicUrl || "https://app.beta.agendor.com.br") + version,
    integrationsURL         : "https://api.agendor.com.br/integrations/google-calendar",
    biURL                   : "https://api.agendor.com.br/bi",
    rdStationIntegrationURL : "https://in.agendor.com.br/rd"
  },
  staging : {
    apiURL                  : "https://api.staging.agendor.com.br/v1",
    apiRailsURL             : "https://api.staging.agendor.com.br/v2",
    webURL                  : "https://web.staging.agendor.com.br",
    webAppURL               : (publicUrl || "https://app.staging.agendor.com.br") + version,
    integrationsURL         : "https://api.staging.agendor.com.br/integrations/google-calendar",
    biURL                   : "https://api.staging.agendor.com.br/bi",
    rdStationIntegrationURL : "https://api.staging.agendor.com.br/rd",
    betaURL                 : "https://beta.staging.agendor.com.br"
  },
  development : {
    apiURL                  : "http://localhost:8000",
    apiRailsURL             : "http://localhost:8003",
    webURL                  : "http://localhost:5000",
    webAppURL               : "http://localhost:8002",
    integrationsURL         : "http://localhost:9090",
    biURL                   : "http://localhost:3000",
    betaURL                 : "http://localhost:3000",
    rdStationIntegrationURL : "http://localhost:3001"
  }
};

const obj = {
  env: env,
  app : {
    host : host,
    port: port,
    webURL : app[env]["webURL"],
    webAppURL : app[env]["webAppURL"],
    apiURL : app[env]["apiURL"],
    apiRailsURL : app[env]["apiRailsURL"],
    integrationsURL : app[env]["integrationsURL"],
    biURL: app[env]["biURL"],
    rdStationIntegrationURL: app[env]["rdStationIntegrationURL"],
    betaURL: app[env]["betaURL"],
    riskUndoImportValidation : process.env.RISK_UNDO_IMPORT_VALIDATION || "AGENDORCRM",
    planDowngradeSecretKey : process.env.PLAN_DOWNGRADE_SECRET_KEY || "AGENDORGRATUITO",
    pro1PlanValue: 53,
    trialDays: 7
  },
  support : {
    phone: process.env.AGENDOR_SUPPORT_PHONE || "(11) 4858-9932",
    email: process.env.AGENDOR_SUPPORT_EMAIL || "contato@agendor.com.br"
  },
  memcache : {
    host : process.env.WEB_CACHE_HOST || "localhost",
    port : process.env.WEB_CACHE_PORT || "11211"
  },
  redis : {
    host : process.env.WEBAPP_CACHE_HOST || "localhost",
    port : process.env.WEBAPP_CACHE_PORT || "6379"
  },
  adyen : {
    cseKey : clientSideEncryptionKey(env)
  },
  sentry: {
    dsn: "https://03fbe52342e44aeda839d06cec0483bb@sentry.io/1886856"
  }
};

validateConfig();

module.exports = obj;

function clientSideEncryptionKey(env) {
  return {
    production : "10001|A651DDD254C513EBFE88FEB8A3D75C181750BA18824407886526A6"
      + "F7A2E81F5657942D170A4EE6DEE5D24A9DD0B1CE5F13CC4472D8E68F3D7D"
      + "AAE67E1D11973D9B63E57C25BE494DA0EDD029D21FF0ACD4A7BD1972E8C3"
      + "36C5CECEEE03E9D6F3E48BB32AD43B38D2AC7D141B63C3294FFB38739A66"
      + "2FE12E6C4D0CD6B087D41DAC266001B82789598A9BE122A450D6D894D413"
      + "B854D3F942E445D1534F102ED11C6BD3214BF79EAB96CD0C13E7BA16A4AF"
      + "EB7F90C14FF6745F9082D5995A5CB99D79CA1D6FC6C250FA5A135B5E2C80"
      + "6865CFF58419D2B5FB57462A5B74BD902199BA3ED90BB8BEE3CEEF3ADBAB"
      + "821DEE31B92252BD8D02BD39E8EE241346DD83",
    beta : "10001|A651DDD254C513EBFE88FEB8A3D75C181750BA18824407886526A6"
      + "F7A2E81F5657942D170A4EE6DEE5D24A9DD0B1CE5F13CC4472D8E68F3D7D"
      + "AAE67E1D11973D9B63E57C25BE494DA0EDD029D21FF0ACD4A7BD1972E8C3"
      + "36C5CECEEE03E9D6F3E48BB32AD43B38D2AC7D141B63C3294FFB38739A66"
      + "2FE12E6C4D0CD6B087D41DAC266001B82789598A9BE122A450D6D894D413"
      + "B854D3F942E445D1534F102ED11C6BD3214BF79EAB96CD0C13E7BA16A4AF"
      + "EB7F90C14FF6745F9082D5995A5CB99D79CA1D6FC6C250FA5A135B5E2C80"
      + "6865CFF58419D2B5FB57462A5B74BD902199BA3ED90BB8BEE3CEEF3ADBAB"
      + "821DEE31B92252BD8D02BD39E8EE241346DD83",
    staging : "10001|B14C58ECFFC20E746FF86E3EFF694E3871B81A1589AE27E8096794"
      + "A9AFFD8DD4FE9B5E05F78B14FA77195BECCD8F0C1D2ECA31B27F8A04FD77"
      + "B1B2B306864C55F8334EDFC9194B4A26690CA12D8D264414B01EF1954FB1"
      + "EA81DC5A1C15FEC770982CA57BEB760753CED23B8E83CB1C42BF3D441924"
      + "65190A6CA497C58407A7FDD91706E40341172A60D708586A55DB6347DEA0"
      + "39A6A3BEE3C3B1F46B50F55E0EDF71D902B055ED78A20F2836282B1CD108"
      + "33BDA9DA839355A72F1BBC5AA737FA32E658BAB0BBD304CF3E42007A3669"
      + "AE98A0E540D2DE3D444A21F3B9CD80287B56F7D8C949BB8204265622E008"
      + "FDFF76379DF6BAC04AB3DC2B5ADF3DB9BD978B",
    development : "10001|B14C58ECFFC20E746FF86E3EFF694E3871B81A1589AE27E8096794"
      + "A9AFFD8DD4FE9B5E05F78B14FA77195BECCD8F0C1D2ECA31B27F8A04FD77"
      + "B1B2B306864C55F8334EDFC9194B4A26690CA12D8D264414B01EF1954FB1"
      + "EA81DC5A1C15FEC770982CA57BEB760753CED23B8E83CB1C42BF3D441924"
      + "65190A6CA497C58407A7FDD91706E40341172A60D708586A55DB6347DEA0"
      + "39A6A3BEE3C3B1F46B50F55E0EDF71D902B055ED78A20F2836282B1CD108"
      + "33BDA9DA839355A72F1BBC5AA737FA32E658BAB0BBD304CF3E42007A3669"
      + "AE98A0E540D2DE3D444A21F3B9CD80287B56F7D8C949BB8204265622E008"
      + "FDFF76379DF6BAC04AB3DC2B5ADF3DB9BD978B"
  }[env];
}


function validateConfig() {

  notNullValueKey(obj.env, "env");
  notNullObjectValues(obj.app);
  notNullObjectValues(obj.memcache);
  notNullObjectValues(obj.redis);
  notNullObjectValues(obj.adyen);

  function notNullObjectValues(object) {
    _.each(object, notNullValueKey);
  }

  function notNullValueKey(value, key) {
    if (value == null){
      throw new Error("Required config is missing - Please define a value to \""+key+"\".");
    }
  }
}



// WEBPACK FOOTER //
// ./app/util/config/config.js